import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { useTablet } from '../../hooks/utilHooks';

const useStyles = makeStyles((theme) => ({
  styleFab: {
    position: 'fixed',
    bottom: theme.spacing(16),
    zIndex: 3,
    cursor: 'pointer',
  },
}));

const FabIcon = () => {
  const isTablet = useTablet();
  const classes = useStyles();
  return (
    <Fab
      color="primary"
      aria-label="Add"
      style={{ right: isTablet ? '2%' : '24%' }}
      className={classes.styleFab}
    >
      <AddIcon />
    </Fab>
  );
};

export default FabIcon;
